function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { ButtonTypes } from "./button-types";
import ProductSignupAndLearnMoreButtons from "./product-signup-and-learn-more-buttons/product-signup-and-learn-more-buttons";
import Label from "./label/label";
import { StyledCardButton } from "./card-button.scss";
const BUTTON_TYPE_TO_COMPONENT = {
    [ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE]: ProductSignupAndLearnMoreButtons,
    [ButtonTypes.LABEL]: Label
};
const CardButton = (_param)=>{
    var { buttonType } = _param, buttonConfig = _object_without_properties(_param, [
        "buttonType"
    ]);
    const ButtonComponent = BUTTON_TYPE_TO_COMPONENT[buttonType];
    return /*#__PURE__*/ _jsx(StyledCardButton, {
        className: "card-button-component",
        children: /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({}, buttonConfig))
    });
};
export default withGenericConfig(CardButton);
